import { btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import PopupResult, { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

import * as ST from './styled';

export interface IPopupState {
    isOpen: boolean,
    title: JSX.Element | string,
    text?: JSX.Element | string,
    type?: EResultPopupStatus,
    actions?: JSX.Element,
}

interface IPopupProps extends IPopupState {
    onClose: () => void,
    isLoading?: boolean,
}

export const defaultPopupState: IPopupState = {
    isOpen: false,
    title: '',
};

const ResultPopup = ({ isOpen, title, text, type = EResultPopupStatus.DEFAULT, actions, onClose }: IPopupProps): JSX.Element => {
    const stTitle = <ST.PopupTitle>{title}</ST.PopupTitle>;
    const _defaultButton = <ST.Button type={btnTypes.SECONDARY} size={btnSizes.LARGE} text={'Закрыть'} onClick={onClose}/>;

    return (
        <PopupResult
            isOpen={isOpen}
            title={stTitle}
            text={text}
            type={type}
            onClose={onClose}
        >
            <ST.PopupFooter>
                {actions || _defaultButton}
            </ST.PopupFooter>
        </PopupResult>
    );
};

export default ResultPopup;
